import * as React from 'react';
import { Button, Box, Stepper, Step, StepLabel } from '@mui/material';
import Manage2faAuthenticatorStep1 from './Manage2faAuthenticatorStep1';
import Manage2faAuthenticatorStep2 from './Manage2faAuthenticatorStep2';
import Manage2faAuthenticatorStep3 from './Manage2faAuthenticatorStep3';
import Manage2faSmsStep1 from './Manage2faSmsStep1';
import Manage2faSmsStep2 from './Manage2faSmsStep2';
import Manage2faSmsStep3 from './Manage2faSmsStep3';
import { removeAuthenticator } from './Manage2faEndpoints';

export default function Manage2faStepper(props) {
    const { method, goBack, profilePhoneNumber } = props;
    const [activeStep, setActiveStep] = React.useState(0);
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [recoveryCodes, setRecoveryCodes] = React.useState([]);
    const [dialogSubmit, setDialogSubmit] = React.useState(0);

    const handleGoToManage2fa = () => {
        goBack();
    }

    const handleOnClickBack = async () => {
        goBack();
        if (method === 'authenticator') {
            await removeAuthenticator();
        }
    }

    const handleSubmit = () => {
        setDialogSubmit(dialogSubmit + 1);
    };

    const handleNext = () => {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    let steps = [];
    const stepsAuthenticator = React.useMemo(() => {
        return [
            {
                label: 'Setup',
                component: (
                    <Manage2faAuthenticatorStep1
                        key={'step-1'}
                        dialogSubmit={dialogSubmit}
                        onValidate={async () => {
                            handleNext();
                        }}

                    />
                )
            },
            {
                label: 'Verify',
                component: (
                    <Manage2faAuthenticatorStep2
                        key={'step-2'}
                        dialogSubmit={dialogSubmit}
                        onValidate={async (formikValues) => {
                            setRecoveryCodes(formikValues);
                            handleNext();
                        }}

                    />
                )
            },
            {
                label: 'Recovery',
                component: (
                    <Manage2faAuthenticatorStep3
                        key={'step-3'}
                        dialogSubmit={dialogSubmit}
                        recoveryCodes={recoveryCodes}
                        onValidate={async () => {
                            handleNext();
                        }}
                    />
                )
            }
        ];
    }, [dialogSubmit, recoveryCodes]);

    const stepsSms = React.useMemo(() => {
        return [
            {
                label: 'Setup',
                component: (
                    <Manage2faSmsStep1
                        key={'step-1'}
                        dialogSubmit={dialogSubmit}
                        profilePhoneNumber={profilePhoneNumber}
                        onValidate={async (formikValues) => {
                            setPhoneNumber(formikValues.phoneNumber);
                            handleNext();
                        }}

                    />
                )
            },
            {
                label: 'Verify',
                component: (
                    <Manage2faSmsStep2
                        key={'step-2'}
                        dialogSubmit={dialogSubmit}
                        phoneNumber={phoneNumber}
                        onValidate={async () => {
                            handleNext();
                        }}
                    />
                )
            },
            {
                label: 'Confirmation',
                component: (
                    <Manage2faSmsStep3
                        key={'step-3'}
                        dialogSubmit={dialogSubmit}
                        onValidate={async () => {
                            handleNext();
                        }}
                    />
                )
            }
        ];
    }, [dialogSubmit, phoneNumber, profilePhoneNumber]);

    if (method === 'authenticator') {
        steps = stepsAuthenticator;
    }
    else {
        steps = stepsSms;
    }

    return (
        <>
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
            {steps.map((step, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                    <Step key={step.label} {...stepProps}>
                        <StepLabel {...labelProps}>{step.label}</StepLabel>
                    </Step>
                );
            })}
        </Stepper>
            {steps[activeStep].component}
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                <Button
                    color="inherit"
                    onClick={activeStep === 0 ? handleOnClickBack : handleBack}
                    sx={{ mr: 1 }}
                >
                    Back
                </Button>
                <Box sx={{ flex: '1 1 auto' }} />
                <Button onClick={activeStep === steps.length - 1 ? handleGoToManage2fa : handleSubmit}>
                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                </Button>
            </Box>
        </>
    );
}